var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4.1 0.041)"},React.createElement("path",{"d":"M3.482,0,0,3.618,13.258,17.371,26.513,3.618,23.031,0,13.257,10.159Z","transform":"translate(5.182 27.513) rotate(-90)","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1.5"})));
}

Right.defaultProps = {"width":"19.533","height":"28.596","viewBox":"0 0 19.533 28.596"};

module.exports = Right;

Right.default = Right;
